/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Unassigned
 * 
 * 1 = GoAhead
 * 
 * 2 = One
 * 
 * 3 = Sixty
 * 
 * 4 = OneHundred
 * 
 * 5 = ThreeHundred
 * 
 * 6 = Vulcan
 * 
 * 7 = Other
 * 
 * 8 = CalReportComplete
 * 
 * 9 = PressureTest
 * 
 * 10 = SalesToProductionHandover
 */
export enum TestMachine {
  Unassigned = 0,
  GoAhead = 1,
  One = 2,
  Sixty = 3,
  OneHundred = 4,
  ThreeHundred = 5,
  Vulcan = 6,
  Other = 7,
  CalReportComplete = 8,
  PressureTest = 9,
  SalesToProductionHandover = 10
}
